/*=========================================================================================
  File Name: mutations.js
  Description: Vuex Store - mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const mutations = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu

  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // VxAutoSuggest

  UPDATE_STARRED_PAGE(state, payload) {
    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex(
      item => item.url == payload.url
    );

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked =
      payload.val;

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(
        state.navbarSearchAndPinList["pages"].data[index]
      );
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex(
        item => item.url == payload.url
      );

      // remove item using index
      state.starredPages.splice(index, 1);
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10);
    state.starredPages = list.concat(starredPagesMore);
  },
  ARRANGE_STARRED_PAGES_MORE(state, list) {
    let downToUp = false;
    let lastItemInStarredLimited = state.starredPages[10];
    const starredPagesLimited = state.starredPages.slice(0, 10);
    state.starredPages = starredPagesLimited.concat(list);

    state.starredPages.slice(0, 10).map(i => {
      if (list.indexOf(i) > -1) downToUp = true;
    });

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited);
    }
  },

  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val;
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO(state, payload) {
    state.AppActiveUser = payload;
    // Get Data localStorage
    // let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

    // for (const property of Object.keys(payload)) {

    //   if (payload[property] != null) {
    //     // If some of user property is null - user default property defined in state.AppActiveUser
    //     state.AppActiveUser[property] = payload[property]

    //     // Update key in localStorage
    //     // userInfo[property] = payload[property]
    //   }

    // }
    // Store data in localStorage
    // localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  // Set Loading
  SET_LOADING(state, value) {
    state.loading = value;
  },
  // Set Error
  SET_ERROR(state, value) {
    state.error = value;
  },
  // Set Refresh Token
  SET_REFRESH_TOKEN(state, value) {
    state.refreshToken = value;
  },
  // Set Access Token
  SET_ACCESS_TOKEN(state, value) {
    state.accessToken = value;
  },
  SET_USERS(state, value) {
    state.allUser = value;
  },
  SET_AN_USER(state, value) {
    state.allUser.unshift(value);
  },
  SET_VIEW_ONLY_USER_ACL(state, value) {
    if (value === undefined || value.length <= 0) {
      state.viewOnlyUserACL = [];
    } else {
      state.viewOnlyUserACL = value;
    }
  },
  SET_VIEW_ONLY_USER_ACL_FOOTFALL(state, value) {
    state.viewOnlyUserACLFootfall = value;
  },
  SET_VIEW_ONLY_USER_ACL_ANALYTICS(state, value) {
    state.viewOnlyUserACLAnalytics = value;
  },
  SET_DOWNLOAD_ANALYTICS(state, value) {
    state.analyticDownload = value;
  },
  SET_SHOWROOMS(state, value) {
    state.showrooms = value;
  },
  SET_A_SHOWROOM(state, value) {
    state.showrooms.unshift(value);
  },
  SET_LINK(state, value) {
    state.link = value;
  },
  SET_META(state, value) {
    state.meta = value;
  },
  SET_APPLICANT_LIST(state, value) {
    state.applicantList = value;
  },
  SET_APPLICANT(state, value) {
    state.applicant = value;
  },
  SET_GAURANTOR_LIST(state, value) {
    state.gaurantorList = value;
  },
  SET_GAURANTOR(state, value) {
    state.gaurantor = value;
  },
  SET_APPLICATION_LIST(state, value) {
    state.applicationList = value;
  },
  SET_APPLICATION(state, value) {
    state.application = value;
  },
  SET_PRODUCT_MASTER_LIST(state, value) {
    state.productMasterList = value;
  },
  SET_DASHBOARD_DATA_LIST(state, value) {
    state.dashboardData = value;
  },
  SET_WASHING_MACHINE_TRAIL(state, value) {
    state.washingMachineTrail = value;
  },
  SET_WM_TRIAL_BY_ID(state, value) {
    state.wmTrailDetailById = value;
  },
  SET_COMPARE_DATA(state, value) {
    state.compareData = value;
  },
  SET_EXCEL_UPLOAD_LOADING (state, value) {
    state.uploadExcelLoad = value
  },
  SET_EXCEL_UPLOAD_DONE (state, value) {
    state.uploadExcelDone = value
  },

  SET_COMPARE_EXCEL_LOADING (state, value) {
    state.compareExcelLoad = value
  },
  SET_COMPARE_EXCEL_DONE (state, value) {
    state.compareExcelDone = value
  },
  SET_PROFILE_UPDATE_DATA(state, value) {
    state.profileList = value;
  },
  SET_PROFILE_DETAILS(state, value) {
    state.profileDetails = value;
  },
  SET_CHANGE_REQ_APPL (state, value) {
    state.changeReqApplList = value
  },
  SET_APPLICANT_PERSONAL_PRO_UPDATE (state, value) {
    state.applicantPersonalProfileUpdate = value
  },

  SET_BLOCKED_APPLICATION_LIST(state, value) {
    state.blockedApplicationList = value;
  },
};

export default mutations;
